import React, { useState } from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import TextField from '../components/TextField';
import { Row } from "../components/Flex";
import { PrimaryButton, SecondaryButton } from "../components/buttons/Buttons";
import SelectField from "../components/SelectField";

interface Props {
    max: number;
    remaining: number;
    open: boolean;
    onClose: () => void;
    onAdd: (type: string, email: string) => void;
}

function CreateUserDialog({ max, remaining, open, onAdd, onClose }: Props) {
    const [email, setEmail] = useState('');

    const onConfirm = () => onAdd('COACH', email);
    const limit = Math.min(max, remaining);
    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Create new user, {limit} more empty slots
                    </DialogTitle>
                    <TextField label="Name" value={email} setValue={setEmail} />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Create" onClick={onConfirm} disabled={!email || limit <= 0} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default CreateUserDialog;
